import { JourneyForm } from 'api/journey-forms/requests';

export const buildStableJourneyFormUrl = (formsBase: string, form: JourneyForm): string => {
  return `${formsBase}/jf/${form.journeyUuid}/${form.uuid}`;
};

export const buildJourneyFormUrl = (formsBase: string, form: JourneyForm): string => {
  if (form.companySlug && form.slug) {
    return `${formsBase}/f/${form.companySlug}/${form.slug}`;
  }
  return buildStableJourneyFormUrl(formsBase, form);
};

export const toDisplayUrl = (url: string): string => {
  try {
    const { pathname, search } = new URL(url);
    return `…${pathname.replace(/^\//, '')}${search}`;
  } catch {
    return url;
  }
};
